import { PerceptionDeduction, PerceptionDeductionAllResponse } from "app/types/configuracion/percepciones_deducciones";
import { toaster } from "app/utilities/commons";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_NET;

/**
 * 
 * @param page 
 * @param pageSize 
 * @returns 
 */
export async function getAllPerceptionsDeductions(page: number | string, pageSize: number | string) {
    try {
        const response = await axios.get<PerceptionDeductionAllResponse>(`${API_URL}PerceptionDeduction?Page=${page}&PageSize=${pageSize}`);
        return response.data.data;
    } catch (err) {
        console.error("Error:", err);
        throw err;
    }
}

/**
 * Filter PerceptionsDeductions by description
 * @param page 
 * @param pageSize 
 * @param description 
 * @returns 
 */
export async function getAllPerceptionsDeductionsFilter(page: number | string, pageSize: number | string, description?: string) {
    let response;
    try {
        console.log("NAME FILTER ", description);
        response = await axios.get<PerceptionDeductionAllResponse>(`${API_URL}PerceptionDeduction?Description=${description}&Page=${page}&PageSize=${pageSize}`);
        console.log("NAME FILTER ", response.data.data);
        return response.data.data;
    } catch (err) {
        console.error("Error fetching Department");
        throw err;
    }
}

export async function perceptionDeductionCreateAndUpdate(body: PerceptionDeduction,) {
    let response;
    const {
        id,
        factorBaseId,
        companyId,
        frequencyId,
        typeMovementId,
        typePerceptionDeductionId,
        code, //key
        description,
        value,
        mandatory,
    } = body;
    if (id) {
        try {
            response = await axios.put(`${API_URL}PerceptionDeduction/${id}`, {
                factorBaseId,
                companyId,
                frequencyId,
                typeMovementId,
                typePerceptionDeductionId,
                key: code,
                description,
                value,
                mandatory,
                id
            });
            toaster.success('Se cambio con éxito la información');
            return response.data;
        } catch (err: any) {
            err.response?.data?.errors.forEach((msg: any) => {
                toaster.error(msg.message)
            });
            console.error('Error UPDATING PerceptionDeduction', err);
            throw err;
        }
    } else {
        try {
            response = await axios.post(`${API_URL}PerceptionDeduction`, {
                factorBaseId,
                companyId,
                frequencyId,
                typeMovementId,
                typePerceptionDeductionId,
                key: code,
                description,
                value,
                mandatory,
            })
            toaster.success("Guardado correctamente");
            return response.data;
        } catch (err: any) {
            err.response?.data?.errors.forEach((msg: any) => {
                toaster.error(msg.message)
            });
            console.error('Error CREATING PerceptionDeduction', err);
            throw err;
        }
    }
}

/**
 * Delete a PerceptionDeduction by id
 * @param id 
 * @returns 
 */
export async function deletePerceptionDeduction(id: number) {
    try {
        const response = await axios.delete(`${API_URL}PerceptionDeduction/${id}`);
        toaster.success('Se eliminó correctamente');
        return response.data;
    } catch (err: any) {
        err.response?.data?.errors?.forEach((msg: any) => {
            toaster.error(msg.message);
        });
        console.error('Error DELETING PerceptionDeduction', err);
        throw err;
    }
}